import PouchDB from "pouchdb";

class Meta {
  databases;

  constructor(databases) {
    this.databases = databases;
  }

  setup(Vue) {
    // create PouchDB('meta')
    // add global hook to:
    //  - push app state to meta
    //  - swap app state
    let self = this;
    Object.defineProperty(Vue.prototype, "$meta", {
      get() {
        return self;
      }
    });
  }

  locrep(db) {
    let uniquify = s => s + "1";
    let rename = uniquify(db.name);
    let redb = new PouchDB(rename);
    console.log(rename, redb, "::", db);
    db.allDocs({ include_docs: true })
      .then(rs => rs.rows.map(r => r.doc))
      .then(ds =>
        ds.forEach(d => {
          console.log(d);
          redb
            .put(d, { new_edits: false })
            .then(console.log)
            .catch(console.log);
        })
      )
      .catch(console.log);
  }

  metaclone(dbs, mb = "meta") {
    let m = new PouchDB(mb);
    console.log("[meta]", mb, "->", m);
    console.log("[meta] cloning", dbs);
    let doc = row => row.doc;
    let exporter = async db => {
      let { name, _prefix } = db;
      let allDocs = await db.allDocs({ include_docs: true }).then(r => {
        let docs = r.rows.map(doc);
        console.log("docs", name, docs);
        return docs;
      });
      return [name, { name, _prefix, allDocs }];
    };
    Promise.all(dbs.map(exporter)).then(entries => {
      let v = Object.fromEntries(entries);
      console.log("v", v);
      let d = JSON.stringify(new Date());
      m.put({ _id: d, databases: v })
        .then(console.log)
        .catch(console.log);
    });
  }

  metas() {
    new PouchDB("meta").allDocs({ include_docs: true }).then(console.log);
  }

  destroy(names) {
    names.forEach(b => {
      new PouchDB(b)
        .destroy()
        .then(console.log)
        .catch(console.log);
    });
  }

  install(Vue, options) {
    this.setup(Vue, options);
    console.log("--- meta:ok ---", Vue, this.databases);
  }
}

export default Meta;
